// extracted by mini-css-extract-plugin
export default {"how":"howItWorks_how__0IuXn","text":"howItWorks_text__mM2cc"};